import { isSubdomainPattern } from './subreddit';

/** Display in UI: /r/CFB, etc. */
export function formatSubredditPlaceTitle(sub: string): string {
  const s = sub.toLowerCase();
  if (s === 'cfb') return 'CFB';
  return sub;
}

export function placeTeamPath(subreddit: string, flairCode: string): string {
  const f = encodeURIComponent(flairCode);
  if (isSubdomainPattern()) return `/place/${f}`;
  return `/${subreddit}/place/${f}`;
}

export function placeBrowsePath(subreddit: string): string {
  if (isSubdomainPattern()) return '/place/browse';
  return `/${subreddit}/place/browse`;
}

export function placeLeaderboardPath(subreddit: string): string {
  if (isSubdomainPattern()) return '/place/leaderboard';
  return `/${subreddit}/place/leaderboard`;
}

export function placeTimelapsePath(subreddit: string): string {
  if (isSubdomainPattern()) return '/place/timelapse';
  return `/${subreddit}/place/timelapse`;
}
